import { render, staticRenderFns } from "./AtencionesTab.vue?vue&type=template&id=a6d8e8b0&"
import script from "./AtencionesTab.vue?vue&type=script&lang=ts&"
export * from "./AtencionesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports